import React from 'react'
import LocationCard from '../../components/LocationCard'
import styled from 'styled-components'
import { queries } from '~/constants/mediaQuery'

export default function GridView({ locations, userIsClient, loading }) {
  return (
    <CardGrid>
      {(
        locations ||
        Array.from({ length: 9 }, (_, index) => ({
          id: `${index}`,
          name: `Loading... ${index}`,
          address: ['Loading...'],
          neighborhood: 'Loading...',
          city: 'Loading...',
          state: 'Loading...',
          status: 'open',
          score: 80,
          code: '123456789',
          url: 'https://www.google.com',
          images: {
            grouped: {},
            all: [],
          },
        }))
      ).map(el => (
        <LocationCard
          key={el.id}
          location={el}
          userIsClient={userIsClient}
          isLoading={loading}
        />
      ))}
    </CardGrid>
  )
}

const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(328px, 1fr));
  gap: 2rem;
  margin-top: 2rem;

  @media (${queries.less.sm}) {
    grid-template-columns: repeat(auto-fill, minmax(328px, 1fr));
  }

  @media ${queries.less.mds} {
    padding: 16px 0;
    margin-top: 0rem;
  }
`
